import { useEffect, useState } from 'react';

import { useAppDispatch, useTypedSelector } from 'store/reducers/use-typed-selector';
import GradientButton from '@general-ui/button/gradient-button';
import { showAlert } from '@general-ui/alert/alert-service';
import Switch from "@general-ui/switch/switch";
import TagSelectInput from '@general-ui/tag-select/tag-select';
import { updateChannelMuxVocabulary } from 'store/actions/authentication';

import './extended-dictionary.scss';

// Extended Dictionary = Brandlive branding terminology
// Mux Vocabulary = Mux branding terminology
function ExtendedDictionary(): JSX.Element {
	const dispatch = useAppDispatch();

	const user = useTypedSelector(state => state.AuthReducer.user);
	const channels = useTypedSelector(state => state.AuthReducer.channels);
	const saving = useTypedSelector(state => state.AuthReducer.savingChannelMuxVocabulary);

	const currentChannel = channels.find((channel) => channel.channel === user?.active_channel);

	const [phrases, setPhrases] = useState<string[]>(currentChannel?.mux_vocabulary?.phrases || []);
	const [enabled, setEnabled] = useState(!!currentChannel?.mux_vocabulary?.enabled);
	const [edited, setEdited] = useState(false);

	useEffect(() => {
		if (currentChannel?.mux_vocabulary?.phrases) {
			setPhrases(currentChannel.mux_vocabulary.phrases);
		}
	}, [currentChannel]);

	const handleSave = async () => {
		if (!user?.active_channel) return;

		try {
			dispatch(updateChannelMuxVocabulary(
				user?.active_channel, 
				{
					mux_vocabulary_id: currentChannel?.mux_vocabulary?.mux_vocabulary_id,
					enabled,
					phrases
				}
			));
		} catch (e) {
			showAlert({
				message: 'Error saving dictionary',
				description: 'Please try again',
				type: 'error',
				duration: 10000
			});
		}
	};

	return (
		<div className="extended-dictionary-container">
			<div className="subheading">
				These configurations apply channel wide
			</div>

			<div className="word-config-container">
				<div className="primary-text">
					Extended Dictionary
				</div>
				<div className="secondary-text">
					Add brand specific terminology
				</div>
				<Switch
					value="extended-dictionary-enabled"
					on={enabled}
					onClick={() => { 
						setEdited(true);
						setEnabled(!enabled);
					}}
					disabled={saving}
				/>
				<TagSelectInput
					onChange={words => {
						setEdited(true);
						setPhrases(words);
					}}
					defaultTags={phrases}
					tags={phrases}
					capSensitive
					noWhitespace
					maxTags={1000}
					allowWithoutEnter={true}
				/>
				<div className="word-count">{phrases.length} / 1000</div>
				<GradientButton
					fullBackgroundGradient
					gradient="--gradient-sunrise"
					wrapperClassNames="save-captions-settings"
					loading={saving}
					buttonProps={{
						disabled: saving || !edited,
						onClick: handleSave
					}}
					adminButton
				>
					Save
				</GradientButton>
			</div>
		</div>
	);
}

export default ExtendedDictionary;